export function classNames(...arr: Array<string | undefined>) {
  return arr.filter(Boolean).join(' ');
}
